<div class="row">
  <div class="col-12">
    <h3>{{ "accounts.cancellation.title" | translate }}</h3>
    <div class="row">
      <div *ngIf="!canceled && mediaAccessActive != null" class="col-12 text-center">
        <p>{{ "accounts.cancellation.info_1" | translate }} <b>{{mediaAccessActive.maskedValue}}</b> {{ "accounts.cancellation.info_2" | translate }}</p>
        <p>{{ "accounts.cancellation.continue" | translate }}</p>
        <button class="btn btn-success" type="button" (click)="cancelAccount()">{{ "accounts.cancellation.yes" | translate }}</button>
      </div>
      <div *ngIf="mediaAccessActive == null" class="col-12">
        <div class="alert alert-warning text-center">
          <p>{{ "accounts.cancellation.not_active" | translate }}</p>
          <p>{{ "accounts.cancellation.only_active" | translate }}</p>
        </div>
      </div>
      <div *ngIf="canceled" class="col-12 text-center">
        <p>{{ "accounts.cancellation.terminated_on" | translate }}</p>
        <p class="font-weight-bold">{{dateRequested}}</p>
      </div>
    </div>
  </div>
</div>
